<style lang="scss" scoped>
.workshopHourOuput::-webkit-scrollbar {
  display: none;
}

.grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 6px 0;

  &:not(:last-child) {
    margin-right: 10px;
  }
}
</style>
<style lang="scss" scoped>
.weier-prodcution-monitor-border {

  border: 1px solid;
  border-image: url("../../../../../../assets/img/web/weier/production/xiankuang2.png") 10 stretch;
}
</style>

<template>
  <div class="workshopHourOuput" ref="container" style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">

    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 0px;box-sizing: border-box;">
      <img style="width: auto;height: 42px;" src="../../../../../../assets/img/web/weier/production/scsjzl.png" />
    </div>
    <div class="weier-prodcution-monitor-border" style="flex:1;display: flex;flex-direction: column;justify-content: space-around;padding: 20px;">

      <div style="display: flex;justify-content: space-between;align-items: center;">
        <div v-for="i in [{ key: 'planNum', name: '计划数' }, { key: 'fenge' }, { key: 'machineNum', name: '机器产出数' }, { key: 'fenge' }, { key: 'reportNum', name: '报工数' }, { key: 'fenge' }, { key: 'inQuantity', name: '入库数' }]">
          <div style="text-align: center;min-width: 90px;" v-if="i.key != 'fenge'">
            <p style=" font-size: 18px;color:rgba(100, 214, 248, 1);font-weight: bold;">{{ datas[i.key] }}</p>
            <p style="font-size: 14px;color:white;margin-top: 8px;">{{ i.name }}</p>
          </div>
          <div v-else style="width: 2px;height:24px;background-color:rgba(100, 214, 248, 0.3);"></div>
        </div>

      </div>

      <div style="width: 100%;height:1px;background-color:rgba(100, 214, 248, 0.3);"></div>


      <div style="display: flex;justify-content: space-between;align-items: center;">
        <div style="" v-for="i in [{ key: 'scheduleQuantity', name: '排产工单数' }, { key: 'fenge' }, { key: 'pauseWoQuantity', name: '暂停工单数' }, { key: 'fenge' }, { key: 'doingWoQuantity', name: '在制工单数' }, { key: 'fenge' }, { key: 'finishWoQuantity', name: '完成工单数' }]">
          <div style="text-align: center;min-width: 90px;" v-if="i.key != 'fenge'">
            <p style=" font-size: 18px;color:rgba(100, 214, 248, 1);font-weight: bold;">{{ datas[i.key] }}</p>
            <p style="font-size: 14px;color:white;margin-top: 8px;">{{ i.name }}</p>
          </div>
          <div v-else style="width: 2px;height:24px;background-color:rgba(100, 214, 248, 0.3);"></div>
        </div>

      </div>
    </div>

  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_customize_weier_monitor_production_shengchan",
  components: {},
  props: {
    datas: {
      type: Object,
      default: () => {
        return {};
      },

    },
  },
  data() {
    return {
      timmer: null,
    };
  },
  watch: {
    "datas"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
    },
  },

  created() {
    this.timmer = setInterval(() => {
    }, 120000);
  },
  activated() {
    this.resize();
  },
  mounted() {
    setTimeout(() => {
      this.resize();
    }, 700);
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {

      }, 800);
    },

  },
};
</script>
